import { PAST_PERFORMANCE, PAST_PERFORMANCE_ERROR, PAST_PERFORMANCE_HIDE_ERROR, PAST_PERFORMANCE_START_LOADER, PAST_PERFORMANCE_STOP_LOADER, PAST_PERFORMANCE_ADD_MSG, PAST_PERFORMANCE_CLEAR_MSG, } from "../interface/iPastPerformance";
const initState = {
    data: {
        type: null,
        list: [],
    },
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
    message: {
        msg: "",
        show: false,
        icon: "",
    },
};
const pastPerformance = (state = initState, action) => {
    switch (action.type) {
        case PAST_PERFORMANCE:
            return Object.assign(Object.assign({}, state), { data: {
                    type: action.payload.data.type,
                    list: action.payload.data.list,
                } });
        case PAST_PERFORMANCE_ADD_MSG:
            return Object.assign(Object.assign({}, state), { message: action.payload.message });
        case PAST_PERFORMANCE_CLEAR_MSG:
            return Object.assign(Object.assign({}, state), { message: initState.message });
        case PAST_PERFORMANCE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case PAST_PERFORMANCE_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case PAST_PERFORMANCE_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case PAST_PERFORMANCE_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default pastPerformance;
